document.addEventListener('DOMContentLoaded', function () {

  (function () {
    function qs(sel, root = document) { return root.querySelector(sel); }
    function qsa(sel, root = document) { return Array.from(root.querySelectorAll(sel)); }

    const panel = qs('[data-login-panel]');
    const overlay = qs('[data-login-overlay]');
    if (!panel || !overlay) return;

    function openLogin(e) {
      if (e) e.preventDefault();
      panel.classList.add('is-open');
      overlay.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.classList.add('lp-lock');

      const email = qs('#CustomerEmail', panel);
      if (email) setTimeout(() => email.focus(), 50);
    }

    function closeLogin() {
      panel.classList.remove('is-open');
      overlay.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('lp-lock');
    }

    qsa('[data-login-open]').forEach(btn => btn.addEventListener('click', openLogin));
    qsa('[data-login-close]').forEach(btn => btn.addEventListener('click', closeLogin));
    overlay.addEventListener('click', closeLogin);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeLogin();
    });
  })();

  function hideEmptyProductTabs() {
    const tabs = document.querySelectorAll('.product-block--tab');

    tabs.forEach(function (tab) {
      const content = tab.querySelector('.collapsible-content__inner');
      if (!content) return;

      const text = content.textContent.trim();
      const hasMedia = content.querySelector('img, video, iframe, table, ul, ol');

      if (text === "" && !hasMedia) {
        tab.style.display = "none";
      }
    });
  }

  hideEmptyProductTabs();

  document.querySelectorAll('[data-stl-right-carousel]').forEach((el) => {
    if (!window.Flickity) return;
    if (el.classList.contains('flickity-enabled')) return;

    const flkty = new Flickity(el, {
      cellAlign: 'left',
      contain: true,
      wrapAround: false,
      pageDots: true,
      prevNextButtons: true,
      imagesLoaded: true,
      adaptiveHeight: false
    });

    flkty.on('imagesLoaded', function () {
      flkty.resize();
      flkty.reposition();
    });

    window.addEventListener('resize', function () {
      flkty.resize();
      flkty.reposition();
    });
  });
});

/* GRID TOGGLE */
document.addEventListener('DOMContentLoaded', function () {
  const links = document.querySelectorAll('a.toolbar-meta__link');
  const gridWrapper = document.querySelector('.collection-grid__wrapper');

  if (!gridWrapper || !links.length) return;

  function toggleGrid(link) {
    gridWrapper.classList.toggle('item-display');

    const currentText = link.textContent.trim();
    const changeText = link.getAttribute('data-changetext');

    if (changeText) {
      link.textContent = changeText;
      link.setAttribute('data-changetext', currentText);
    }
  }

  links.forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      toggleGrid(link);
    });
  });

  // auto-trigger on first load
  if (!gridWrapper.classList.contains('item-display')) {
    toggleGrid(links[0]);
  }
});

/* FILTER DRAWER */
document.addEventListener('DOMContentLoaded', function () {
  const html = document.documentElement;
  const body = document.body;
  let filterTimer = null;

  function getFilterDrawer() {
    return document.querySelector('#FilterDrawer');
  }

  function getFilterButtons() {
    return document.querySelectorAll('.filter-btn, [aria-controls="FilterDrawer"], .js-drawer-open-collection-filters');
  }

  function isFilterOpen() {
    const filterDrawer = getFilterDrawer();
    return !!(
      filterDrawer &&
      (filterDrawer.classList.contains('drawer--is-open') || filterDrawer.classList.contains('is-open'))
    );
  }

  function openFilterDrawer() {
    const filterDrawer = getFilterDrawer();
    if (!filterDrawer) return;

    clearTimeout(filterTimer);

    // close sort drawer first
    const sortDrawer = document.querySelector('.sortby-drawer');
    const sortBtn = document.querySelector('.sort-btn');
    if (sortDrawer) {
      sortDrawer.classList.remove('opened-drawer');
      sortDrawer.setAttribute('aria-hidden', 'true');
    }
    if (sortBtn) {
      sortBtn.setAttribute('aria-expanded', 'false');
    }

    filterDrawer.style.display = '';
    filterDrawer.removeAttribute('hidden');
    filterDrawer.setAttribute('aria-hidden', 'false');

    html.classList.add('js-drawer-open', 'lock-scroll');
    body.classList.add('js-drawer-open', 'lock-scroll');

    getFilterButtons().forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'true');
    });

    requestAnimationFrame(function () {
      filterDrawer.classList.add('is-open', 'drawer--is-open');
    });
  }

  function closeFilterDrawer() {
    const filterDrawer = getFilterDrawer();
    if (!filterDrawer) return;

    filterDrawer.classList.remove('is-open', 'drawer--is-open');
    filterDrawer.setAttribute('aria-hidden', 'true');

    html.classList.remove('js-drawer-open', 'lock-scroll');
    body.classList.remove('js-drawer-open', 'lock-scroll');

    getFilterButtons().forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
    });

    clearTimeout(filterTimer);
    filterTimer = setTimeout(function () {
      if (!isFilterOpen()) {
        filterDrawer.style.display = '';
      }
    }, 320);
  }

  document.addEventListener('click', function (e) {
    const filterDrawer = getFilterDrawer();
    const openBtn = e.target.closest('.filter-btn, [aria-controls="FilterDrawer"], .js-drawer-open-collection-filters');
    const closeBtn = e.target.closest('#FilterDrawer .js-drawer-close, #FilterDrawer .drawer__close-button, #FilterDrawer [data-drawer-close]');
    const clickedInsideDrawer = e.target.closest('#FilterDrawer');

    if (openBtn) {
      e.preventDefault();
      e.stopPropagation();

      if (isFilterOpen()) {
        closeFilterDrawer();
      } else {
        openFilterDrawer();
      }
      return;
    }

    if (!filterDrawer || !isFilterOpen()) return;

    if (closeBtn) {
      e.preventDefault();
      e.stopPropagation();
      closeFilterDrawer();
      return;
    }

    // outside click closes the drawer
    if (!clickedInsideDrawer) {
      closeFilterDrawer();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isFilterOpen()) {
      closeFilterDrawer();
    }
  });
});

/* SORT DRAWER */
document.addEventListener('DOMContentLoaded', function () {
  const sortBtn = document.querySelector('.sort-btn');
  const sortDrawer = document.querySelector('.sortby-drawer');
  const html = document.documentElement;
  const body = document.body;

  if (!sortBtn || !sortDrawer) return;

  function openSortDrawer() {
    sortDrawer.classList.add('opened-drawer');
    sortDrawer.setAttribute('aria-hidden', 'false');
    sortBtn.setAttribute('aria-expanded', 'true');

    html.classList.add('js-drawer-open', 'lock-scroll');
    body.classList.add('js-drawer-open', 'lock-scroll');

    const leftDrawer = document.querySelector('.drawer--left');
    if (leftDrawer) {
      leftDrawer.classList.remove('drawer--is-open', 'is-open');
      leftDrawer.setAttribute('aria-hidden', 'true');
    }

    const filterDrawer = document.querySelector('#FilterDrawer');
    if (filterDrawer) {
      filterDrawer.classList.remove('drawer--is-open', 'is-open');
      filterDrawer.setAttribute('aria-hidden', 'true');
    }

    const filterBtn = document.querySelector('.js-drawer-open-collection-filters, .filter-btn, [aria-controls="FilterDrawer"]');
    if (filterBtn) {
      filterBtn.setAttribute('aria-expanded', 'false');
    }
  }

  function closeSortDrawer() {
    sortDrawer.classList.remove('opened-drawer');
    sortDrawer.setAttribute('aria-hidden', 'true');
    sortBtn.setAttribute('aria-expanded', 'false');

    html.classList.remove('js-drawer-open', 'lock-scroll');
    body.classList.remove('js-drawer-open', 'lock-scroll');
  }

  sortBtn.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    if (sortDrawer.classList.contains('opened-drawer')) {
      closeSortDrawer();
    } else {
      openSortDrawer();
    }
  });

  sortDrawer.addEventListener('click', function (e) {
    const closeBtn = e.target.closest('.js-drawer-close');
    if (!closeBtn) return;

    e.preventDefault();
    e.stopPropagation();
    closeSortDrawer();
  });

  document.addEventListener('click', function (e) {
    if (!sortDrawer.classList.contains('opened-drawer')) return;
    if (e.target.closest('.sortby-drawer')) return;
    if (e.target.closest('.sort-btn')) return;

    closeSortDrawer();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && sortDrawer.classList.contains('opened-drawer')) {
      closeSortDrawer();
    }
  });
});

/* ACTIVE SORT FROM URL */
document.addEventListener('DOMContentLoaded', function () {
  const urlParams = new URLSearchParams(window.location.search);
  const currentSort = urlParams.get('sort_by');

  if (!currentSort) return;

  const links = document.querySelectorAll('.sortby-drawer a');

  links.forEach(function (link) {
    const linkUrl = new URL(link.href);
    const linkSort = linkUrl.searchParams.get('sort_by');

    if (linkSort === currentSort) {
      link.classList.add('active-sort');
    }
  });
});

/* BUILD SORT URLS */
document.addEventListener('DOMContentLoaded', function () {
  const sortLinks = document.querySelectorAll('.sortby-drawer a[data-sort-value]');

  sortLinks.forEach(function (link) {
    const sortValue = link.getAttribute('data-sort-value');
    if (!sortValue) return;

    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sortValue);
    url.searchParams.delete('page');

    link.setAttribute('href', url.pathname + url.search);
  });
});

/* ACTIVE SORT STATE */
document.addEventListener('DOMContentLoaded', function () {
  const sortLinks = document.querySelectorAll('.sortby-drawer a[data-sort-value]');
  const currentUrl = new URL(window.location.href);
  const currentSort = currentUrl.searchParams.get('sort_by');

  sortLinks.forEach(function (link) {
    const sortValue = link.getAttribute('data-sort-value');
    const url = new URL(window.location.href);

    url.searchParams.set('sort_by', sortValue);
    url.searchParams.delete('page');
    link.setAttribute('href', url.pathname + url.search);

    link.classList.remove('active-sort');

    if (currentSort && sortValue === currentSort) {
      link.classList.add('active-sort');
    }
  });
});

/* VARIANT CLICK HANDLER */
document.addEventListener('click', function (e) {
  var variantInput = e.target.closest('.variant-input');
  if (!variantInput) return;

  var wrap = variantInput.closest('.variant-input-wrap');
  if (!wrap) return;

  var radio = variantInput.querySelector('input[type="radio"]');
  var isDisabled =
    variantInput.classList.contains('disabled') ||
    variantInput.classList.contains('soldout') ||
    variantInput.classList.contains('unavailable') ||
    (radio && radio.disabled);

  if (isDisabled) {
    e.preventDefault();
    return;
  }

  wrap.querySelectorAll('.variant-input').forEach(function (el) {
    el.classList.remove('is-clicked', 'is-selected');
  });

  variantInput.classList.add('is-clicked', 'is-selected');

  if (radio) {
    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
  }
});

/* SIZE OPTIONS INIT */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-size-options]').forEach(function (sizeWrap) {
    var sizes = Array.from(sizeWrap.querySelectorAll('.size-option'));
    var selectedEl = sizeWrap.querySelector('.size-option.is-selected');
    var card = sizeWrap.closest('[data-product-card]');
    var quickShopTrigger = card ? card.querySelector('.product-details-icon') : null;

    if (!sizes.length) {
      sizeWrap.setAttribute('data-selected-size', '');

      if (quickShopTrigger) {
        quickShopTrigger.classList.add('is-disabled', 'is-sold-out');
        quickShopTrigger.setAttribute('aria-disabled', 'true');
        quickShopTrigger.setAttribute('tabindex', '-1');
        quickShopTrigger.style.pointerEvents = 'none';
        quickShopTrigger.style.opacity = '0.4';
      }

      return;
    }

    if (!selectedEl) {
      var firstAvailable = sizes.find(function (el) {
        return Number(el.getAttribute('data-size-stock') || 0) > 0;
      });

      if (firstAvailable) {
        firstAvailable.classList.add('is-selected');
        sizeWrap.setAttribute('data-selected-size', firstAvailable.getAttribute('data-size-value'));
      } else {
        sizeWrap.setAttribute('data-selected-size', '');
      }
    } else {
      var selectedStock = Number(selectedEl.getAttribute('data-size-stock') || 0);

      if (selectedStock <= 0) {
        selectedEl.classList.remove('is-selected');

        var nextAvailable = sizes.find(function (el) {
          return Number(el.getAttribute('data-size-stock') || 0) > 0;
        });

        if (nextAvailable) {
          nextAvailable.classList.add('is-selected');
          sizeWrap.setAttribute('data-selected-size', nextAvailable.getAttribute('data-size-value'));
        } else {
          sizeWrap.setAttribute('data-selected-size', '');
        }
      } else {
        sizeWrap.setAttribute('data-selected-size', selectedEl.getAttribute('data-size-value'));
      }
    }

    var hasAvailableSize = sizes.some(function (el) {
      return Number(el.getAttribute('data-size-stock') || 0) > 0;
    });

    if (quickShopTrigger) {
      if (hasAvailableSize) {
        quickShopTrigger.classList.remove('is-disabled', 'is-sold-out');
        quickShopTrigger.removeAttribute('aria-disabled');
        quickShopTrigger.removeAttribute('tabindex');
        quickShopTrigger.style.pointerEvents = '';
        quickShopTrigger.style.opacity = '';
      } else {
        quickShopTrigger.classList.add('is-disabled', 'is-sold-out');
        quickShopTrigger.setAttribute('aria-disabled', 'true');
        quickShopTrigger.setAttribute('tabindex', '-1');
        quickShopTrigger.style.pointerEvents = 'none';
        quickShopTrigger.style.opacity = '0.4';
      }
    }
  });
});

/* AUTO-SELECT NEXT AVAILABLE PRODUCT VARIANT */
document.addEventListener('DOMContentLoaded', function () {
  if (!document.body.classList.contains('template-product')) return;

  const variantWrap = document.querySelector('.variant-input-wrap');
  if (!variantWrap) return;

  const variantInputs = variantWrap.querySelectorAll('.variant-input');
  if (!variantInputs.length) return;

  const firstVariant = variantInputs[0];
  if (!firstVariant.classList.contains('out-of-stock')) return;

  const nextAvailable = Array.from(variantInputs).find(function (item, index) {
    return index > 0 && !item.classList.contains('out-of-stock');
  });

  if (nextAvailable) {
    nextAvailable.click();
    const variantId = nextAvailable.getAttribute('data-variant-id');

    if (variantId) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url.toString());
    }
  }
});

/* SHOP THE LOOK MODALS */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.shop-the-look-featured .modal--quick-shop').forEach(function (modal) {
    document.body.appendChild(modal);
  });
});

/* MOBILE NAV LABEL CLICK */
document.addEventListener('DOMContentLoaded', function () {
  const labels = document.querySelectorAll('.mobile-nav__has-sublist .mobile-nav__link--top-level');

  labels.forEach(function (label) {
    label.addEventListener('click', function () {
      const parent = label.closest('.mobile-nav__has-sublist');
      const toggleButton = parent ? parent.querySelector('.mobile-nav__toggle .collapsible-trigger') : null;

      if (toggleButton) {
        toggleButton.click();
      }
    });
  });
});

/* PREVENT FILTER AUTO-CLOSE */
document.addEventListener('DOMContentLoaded', function () {
  var filterForm = document.getElementById('FilterForm-SidebarDrawer');
  if (!filterForm) return;

  function blockAutoApply(e) {
    var target = e.target;
    if (!target.matches('input[type="checkbox"], input[type="radio"]')) return;
    e.stopImmediatePropagation();
  }

  filterForm.addEventListener('input', blockAutoApply, true);
  filterForm.addEventListener('change', blockAutoApply, true);
});

/* MOBILE PRODUCT GALLERY FRACTION NAV */
(function () {
  var mobileMQ = window.matchMedia('(max-width: 768px)');

  function isMobile() {
    return mobileMQ.matches;
  }

  function destroyMockupFractionNav(root) {
    (root || document).querySelectorAll('.flickity-enabled').forEach(function (slider) {
      slider.classList.remove('has-mockup-fraction-nav');
      slider.dataset.mockupFractionNavInit = 'false';

      var nav = slider.querySelector('.product-gallery-fraction-nav');
      if (nav) nav.remove();
    });
  }

  function initMockupFractionNav(root) {
    if (!window.Flickity || !isMobile()) return;

    (root || document).querySelectorAll('.flickity-enabled').forEach(function (slider) {
      if (slider.dataset.mockupFractionNavInit === 'true') return;
      if (!slider.querySelector('.product-main-slide')) return;

      var flkty = Flickity.data(slider);
      if (!flkty) return;

      slider.dataset.mockupFractionNavInit = 'true';
      slider.classList.add('has-mockup-fraction-nav');

      var nav = document.createElement('div');
      nav.className = 'product-gallery-fraction-nav';
      nav.innerHTML = `
        <button type="button" class="product-gallery-fraction-nav__btn" data-gallery-prev aria-label="Previous image">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <g clip-path="url(#clip0_8309_4575)">
              <path d="M0.15 7.64689L-0.203125 8.00001L0.15 8.35314L5.65 13.8531L6.00313 14.2063L6.70937 13.5L6.35625 13.1469L1.70938 8.50001H16.0031V7.50001H1.70938L6.35625 2.85314L6.70937 2.50001L6.00313 1.79376L0.15 7.64689Z" fill="black"/>
            </g>
            <defs>
              <clipPath id="clip0_8309_4575">
                <rect width="16" height="16" fill="white"/>
              </clipPath>
            </defs>
          </svg>
        </button>
        <div class="product-gallery-fraction-nav__count" data-gallery-count>1/1</div>
        <button type="button" class="product-gallery-fraction-nav__btn" data-gallery-next aria-label="Next image">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <g clip-path="url(#clip0_8309_4577)">
              <path d="M15.8563 8.35314L16.2094 8.00001L15.8563 7.64689L10.3563 2.14689L10.0032 1.79376L9.29692 2.50001L9.65005 2.85314L14.2969 7.50001H0.00317383V8.50001H14.2969L9.65005 13.1469L9.29692 13.5L10.0032 14.2063L15.8563 8.35314Z" fill="black"/>
            </g>
            <defs>
              <clipPath id="clip0_8309_4577">
                <rect width="16" height="16" fill="white"/>
              </clipPath>
            </defs>
          </svg>
        </button>
      `;

      slider.appendChild(nav);

      var prevBtn = nav.querySelector('[data-gallery-prev]');
      var nextBtn = nav.querySelector('[data-gallery-next]');
      var countEl = nav.querySelector('[data-gallery-count]');

      function updateNav() {
        var total = flkty.slides.length || 1;
        var current = (flkty.selectedIndex || 0) + 1;

        countEl.textContent = current + '/' + total;
        prevBtn.disabled = current <= 1;
        nextBtn.disabled = current >= total;
      }

      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        flkty.previous();
      });

      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        flkty.next();
      });

      flkty.on('select', updateNav);
      flkty.on('settle', updateNav);

      updateNav();
    });
  }

  function refreshMockupFractionNav(root) {
    if (isMobile()) {
      initMockupFractionNav(root);
    } else {
      destroyMockupFractionNav(root);
    }
  }

  function bootMockupFractionNav(attempts) {
    refreshMockupFractionNav(document);

    if (attempts <= 0) return;

    setTimeout(function () {
      bootMockupFractionNav(attempts - 1);
    }, 400);
  }

  document.addEventListener('DOMContentLoaded', function () {
    bootMockupFractionNav(10);
  });

  document.addEventListener('shopify:section:load', function (e) {
    refreshMockupFractionNav(e.target);
  });

  window.addEventListener('resize', function () {
    refreshMockupFractionNav(document);
  });
})();